import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageCategorias from './pages/categorias.js'
import PageCategoria from './pages/pageCategoria.js'

import PageSuperJuri from './pages/superJuri.js'
import PageSuperJuriSingle from './pages/superJuriSingle.js'
import PageRegulamento from './pages/faq.js'
import PageLogin from "./pages/Login";
import pageIndicacao from './pages/pageIndicacao.js'
import UseMouseOrKeyboard from "./modules/UseMouseOrKeyboard";
import DesignSystem from "./DesignSystem/DesignSystem";
import { register } from 'swiper/element/bundle';
import logs from "./utils/logs";
import ripple from "./modules/ripple";
import formErros from "./modules/formErros";
import animaAoScroll from "./animation/animaAoScroll";
import animateSetup from "./animation/animateSetup";
import animationNumbers from './pages/counter.js'
import getApiAtletas from './pages/get_api_atletas'
import pageVotacao from './pages/pageVotacao'
import pageIndicacaoFase2 from './pages/pageIndicacao-fase-2'
import pageIndicacaoFase2SuperJuri from './pages/pageIndicacao-super-juri-fase-2'
import PlayVideo from './modules/playVideo'


import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
console.log('deploy novo  segunda vez 16/09/2025')

getApiAtletas()
// import SvgUse from "./utils/SvgUse";
 
// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component
const date = new Date();
console.log(date);

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
animationNumbers()
PlayVideo()


// Pages
PageHome()
PageCategorias()
PageCategoria()
PageRegulamento()
PageSuperJuri()
PageSuperJuriSingle()


pageVotacao()

// ===== FASE 1 (ativa): votação por select + campo "Outro" =====
pageIndicacao()


// ===== FASE 2 — comentada para voltar à Fase 1 (não excluir) =====
// pageIndicacaoFase2()

// pageIndicacaoFase2SuperJuri()

PageLogin()?.init()  

Fancybox.bind('[data-fancybox="custom-hero"]', {
	Toolbar: {
		display: ["fullscreen", "close"],
	},
	plugins: {
		fullscreen: true,
	},
	video: {
		autoStart: true,
	},
	on: {
		done: (fancybox, slide) => {

			setTimeout(() => {
				// Acesse diretamente slide.contentEl e procure oz <video>
				const videoEl = slide.contentEl?.querySelector?.("video");
				console.log('videoEl', slide.contentEl);
				console.log('videoEl', videoEl);
				if (videoEl && videoEl.requestFullscreen) {
					videoEl.requestFullscreen().catch((err) => {
						console.warn("Erro ao entrar em fullscreen:", err);
					});
				} else {
					console.log("Vídeo não encontrado ou não suportado para fullscreen.");
				}
			}, 100); // tempo para garantir que o DOM foi inserido
		},
	},
});


// utils logs
logs()



